declare var process:any;

export const backendUrl = process.env.VUE_APP_BACKEND_URL;
export const graphqlBaseUrl = process.env.VUE_APP_GRAPHQL_HTTP || 'https://stag-lister-api.droidox.com/graphql'
export const BASE_URL = backendUrl;
export const ENV = process.env.NODE_ENV;